
  <div class="main-content">   
    <ng-template #nodeTemplateRef let-node>
        <div *ngIf="node.isVisible" class="accordion-item" [ngClass]="['itemLevel' + node.depth]" [class.open]="node.isOpen" [class.closed]="!node.isOpen" [class.isRoot] = "node.isRoot">
            <div *ngIf="node.categoryName" class="accordion-header" [ngClass]="['headerLevel' + node.depth]" (click)="onAccordionToggle($event, node)">
                <span [ngStyle]="{'padding-left': node.depth > 2 ? (node.depth - 1) * 8 + 'px' : 0}">{{node.categoryDisplay}}</span>
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
            </div>
            <div class="accordion-body" [class.isRoot] = "node.isRoot" [ngClass]="['bodyLevel' + node.depth]" [class.isSupportDocument]="node.isSupportDocument" [class.noSubcategories]="node.subCategories.length == 0">
           
        <ng-container *ngIf="node.isOpen && node.path && matchingCategoryProducts(node) as products">             
            <div *ngIf="products.length">
                <div class="search-bar item" [ngStyle]="{'padding-left': node.depth > 2 ? (node.depth - 1) * 8 + 'px' : 0}">
                    <div class="input-group">
                        <input class="form-control py-2 border-right-0 border" type="search" placeholder="Search {{node.categoryDisplay}}" [(ngModel)]="searchValues[node.path]">
                        <span class="input-group-append">
                            <div class="input-group-text bg-transparent"><i class="fa fa-search"></i></div>
                        </span>
                    </div>
                    </div>
            </div>
            <div *ngIf="node.isOpen && filteredProductList(node.path, products) as visibleProducts" [ngClass]="{'accordion-content': products && products.length}" [ngStyle]="{'padding-left': node.depth === 1 ? 10 : (node.depth + 1) * 8 + 'px'}">
                <ng-container *ngFor="let p of visibleProducts">
                    <app-checkbox [text]="p.productCode" [(ngModel)]="p.isSelected" (click)="onProductSelected()" class="product-checkbox"></app-checkbox>
                </ng-container>
            </div>          
        </ng-container>

            <div *ngIf="node.subCategories.length">                    
                <ng-template
                    ngFor
                    [ngForOf]="node.subCategories"
                    [ngForTemplate]="nodeTemplateRef">
                </ng-template>
    
            </div>
            </div>
        </div>
    </ng-template>
    <div class="search-panel">
        <span>Products</span>
        <span *ngIf="(user$ | async).isLoggedIn" class="project-search" (click)="onProjectSearchLaunch()"><i class="fa fa-search" aria-hidden="true"></i>Search for a Project</span>
    </div>
    <div class="category-instruction">Click below to expand categories and add products to your submittal package.</div>
        <div class="accordion-wrapper">
            <app-loading *ngIf="isLoadingProjects" app-loading></app-loading>
    <ng-template
	[ngTemplateOutlet]="nodeTemplateRef"
	[ngTemplateOutletContext]="{ $implicit: productHierarchy.root}">
    </ng-template>
   
   
</div> 
<div class="right-column">
    <div class="search-by-quote-panel">
        <div class="search-by-quote-panel-header">
            Search for Quote
        </div>
        <div *ngIf="quoteErrorMessage" class="errorMessage">{{quoteErrorMessage}}</div>
        <mat-form-field>
            <mat-label>Quote Number</mat-label>
            <input matInput type="text" autocomplete="off" [(ngModel)]="quoteNumber" (ngModelChange)="onQuoteNumberChange($event)">    
        </mat-form-field>
        <mat-form-field>
            <mat-label>Customer Number</mat-label>
            <input matInput type="text" autocomplete="off" [(ngModel)]="navCustomerNo">    
        </mat-form-field>
        <app-button label="Search" class="save-btn project" className="primary" (onClick)="searchForQuote()" [disabled]="!quoteNumber || !navCustomerNo" [showSpinner]="showQuoteSpinner"></app-button>
    </div>
        
    <div class="project-panel">
        <div class="project-panel-header" [class.has-data]="selectedCategories.length">
            Product Submittal         
            <span class="reset-submittal" (click)="onReset()">Clear All <br/>and Create New</span>
        </div>
        <div *ngIf="!(selectedCategories.length === 0)">
        <span class="unsaved-changes" *ngIf="hasUnsavedChanges">*Unsaved Changes -<span class="undo" (click)="onUndo()">undo</span></span>
        <span [className]="selectedCategories.length === 0 ? 'action-row disabled' : 'action-row'">
            <span (click)="onDownloadPdf()" title="Generate PDF">PDF</span>|
            <span (click)="onEmailPdf()" [title]="user.isLoggedIn ? 'Generate and email PDF' : 'Please log in to send an email'" [class.disabled]="!user.isLoggedIn">Email</span>|
            <span (click)="onDownloadZip()" title="Generate zip file with PDF document(s)">Zip</span>
        </span>
        <div class="top-bar">
            <div>            
            <span class="project-title">Current Project
                <span class="detail-links" *ngIf="user.isLoggedIn && !(project.projectId === 0)">
                <span class="hyphen">-</span>
                <span class="detail-link" (click)="onEditProject()" title="Edit Project Details">Edit</span>  
                <span class="detail-link-separator">|</span>
                <span class="detail-link" (click)="onCopyProject()" title="Copy data to a new project">Copy</span>
                </span>
            </span>
            <span class="project-name">{{project.projectName}}</span>
            </div>                   
        </div>
        <div class="selected-items">
            <span class="group" *ngFor="let p of selectedCategories">
                    <span class="group-title">{{p.parentCategoryDisplay}}</span>
                    <span *ngFor="let p of (selectedProducts | arrayFilter:'categoryLineNo':p.categoryLineNo)" class="item">
                       <span>{{p.productCode}}</span>
                       <!--<i class="fa fa-times" aria-hidden="true" (click)="onRemoveProduct(p)"></i>-->
                       <span class="remove-item" (click)="onRemoveProduct(p)">Remove</span>
                    </span>
                </span>
        </div> 
        <div class="add-track">
            <app-checkbox text="Add Track" [(ngModel)]="project.addTrack" [disabled]="project.isQuote"></app-checkbox>
        </div>
    </div>
       <ng-container *ngIf="!(selectedCategories.length === 0); else elseBlock" >
        <app-button (onClick)="onSaveProject()" label="Save Project" class="save-btn project" className="primary" [showSpinner]="showSpinner"></app-button>
       </ng-container>
        
        <ng-template #elseBlock>
            <div class="no-selected-items">No Products Selected</div>
          </ng-template>
    
    </div>  
</div>
   
  </div>